import { Box, Button } from '@ori-ui/mui';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationKeys } from '../../models';
import { Dialog } from '../Dialog';
import { boxFlexDirection } from './styles';
import type { RestoreProps } from './types';

export const Restore = ({ onClose, onContinue, onReset, show = false }: RestoreProps) => {
  const [open, setOpen] = useState(show);
  const [translate] = useTranslation();
  const handleOnClose = useCallback(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  useEffect(() => {
    setOpen(show);
  }, [show]);

  return (
    <Dialog
      header={translate(TranslationKeys.Recommendation)}
      open={open}
      onClose={handleOnClose}
    >
      <Box
        display="flex"
        flexDirection={boxFlexDirection}
        gap={4}
        mx={8}
      >
        <Button
          color="secondary"
          variant="outlined"
          size="large"
          onClick={onReset}
        >
          {translate(TranslationKeys.GetNewRecommendation)}
        </Button>
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={onContinue}
        >
          {translate(TranslationKeys.SeeRecommendedProduct)}
        </Button>
      </Box>
    </Dialog>
  );
};
